module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAQCAYAAAAFzx/vAAABL0lEQVRIS53VsU6DQBzH8d+RkMDAdE5sxUUT21U3Zyc79xWqm/Eh7Nj4Cp3r5OymazXVRbp18iZi7hISUP5pjbRw3B3z3X3guC8wKVUJy2u6XtOM6zi2nAkwW3AuBEYf7wTNjo4x5NwKtQKfswwXb69QRUFI4Hl4POnjLIqMUWPwU0mcLxYQeV5bnPs+ngYDHAahEWoEfuU5YamSjYsmQUjoge93op2gLAraxpcs0y52GkW0vaHnacdpwepNVQfkQYjOO68GXHJOB0lHasGbVYr7TQJGIoCrOMakl7QObwWr1m5XqalTG3fXS1obbQS3rVl/ETYs0zS6B+625vSImkZrYFtrrmhTo39gV2uu6G6jBJq25or+b5R9S1XatOaKbhtl4+WytG3NFR3//s5+ADnNsZBu2xJcAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/arrow_up.png
// module id = +xBv
// module chunks = 2